import SubscriptionService from "src/services/SubscriptionService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	FETCH_PROJECT: "subscription/fetch_project",
	FETCH_USER: "subscription/fetch_user"
};
export const params = {};

/**
 @namespace
 @property  {object} module,
 @property  {object} module.state,
 @property  {object} modules.project,
 @property  {array}  modules.projects
 **/

const module = {
	state: {},
	mutations: {
		[types.FETCH_PROJECT](state, subscriptions) {
			state.subscriptions = subscriptions;
		},
		[types.FETCH_USER](state, subscriptions) {
			state.subscriptions = subscriptions;
		}
	},
	getters: {},
	actions: {
		[types.FETCH_PROJECT](context, payload) {
			return SubscriptionService.getProjectSubscription(payload).then(
				response => {
					context.commit(types.FETCH_PROJECT, response);
				}
			);
		},
		[types.FETCH_USER](context, payload) {
			return SubscriptionService.getUserSubscriptions(payload).then(
				response => {
					context.commit(types.FETCH_USER, response);
				}
			);
		}
	},
	types: types
};
export default ModuleCreator(
	"subscription",
	SubscriptionService,
	module,
	types,
	params
);
